(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/my-orders/components/order-table.js');
"use strict";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const {
  Table,
  TableRow,
  TableBody,
  TableHeader,
  TableHead
} = svs.ui.reactTable;
const {
  NAME,
  COUNT,
  PRICE,
  VALID_UNTIL
} = svs.ticket_partner.myOrders.constants.TEXTS.TABLE_HEADER;
const {
  OrderTableRow
} = svs.ticket_partner.myOrders.components;
const {
  OrderSum
} = svs.ticket_partner.myOrders.components;
const OrderTable = _ref => {
  let {
    batches
  } = _ref;
  return React.createElement(Table, {
    large: true,
    striped: true
  }, React.createElement(TableHead, null, React.createElement(TableRow, null, React.createElement(TableHeader, null, NAME), React.createElement(TableHeader, null, COUNT), React.createElement(TableHeader, null, VALID_UNTIL), React.createElement(TableHeader, null, PRICE))), React.createElement(TableBody, null, batches === null || batches === void 0 ? void 0 : batches.map((batch, i) => React.createElement(OrderTableRow, _extends({
    key: _.uniqueId(i)
  }, batch))), React.createElement(OrderSum, {
    batches: batches
  })));
};
svs.ticket_partner.myOrders.components.OrderTable = OrderTable;

 })(window);